/**
 * Parses the header's year selector value into a year_of_passing filter.
 * The dropdown now shows plain graduation years ("2026") rather than
 * academic-year ranges, so this is a direct 1:1 parse — no offset — plus
 * "All Years" (or anything non-numeric) correctly resolving to undefined
 * (no filter). Shared by every page that filters student-scoped data off
 * the header's selector (college-overview, college-students) so the parsing
 * rule only lives once.
 */
export function parseYearOfPassing(selectedYear: string): number | undefined {
  const match = selectedYear.match(/^(\d{4})$/);
  return match ? parseInt(match[1], 10) : undefined;
}

/**
 * Builds the shared year-dropdown option list ("All Years" + the distinct
 * year_of_passing values actually present among the college's students,
 * descending) — used identically by college-header.component.ts's selector
 * and college-settings.component.ts's "Default academic year" picker, so
 * both always offer the exact same options rather than two hand-rolled
 * copies that could drift apart.
 */
export function buildYearDropdownOptions(availableYears: number[]): string[] {
  const sorted = [...availableYears].sort((a, b) => b - a);
  return ['All Years', ...sorted.map((y) => `${y}`)];
}
